export const SMART_FLAGS_CHECK = "SMART_FLAGS_CHECK";

export const checkSmartFlags = (jobId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SMART_FLAGS_CHECK,
        payload: {
          request: {
            mode: "no-cors",
            url: 'smart-flag/check-job',
            method: "POST",
            data: {
              jobId: jobId,
            }
          }
        }
      }).then(response => {
        resolve(response.payload);
      });
    });
  };
};


export const RESET_SMART_FLAGS = "RESET_SMART_FLAGS";
export const resetSmartFlags = () => ({
  type: RESET_SMART_FLAGS
});
